import { getLocalAuth } from "../../utils/AuthUtils";
import ErrorNotFound from "../errors/Error";
import ActivityReport from "./ActivityReport";
import MostUsedPart from "./MostUsedPart";
import RackStorage from "./RackStorage";
import SummaryDashboard from "./SummaryDashboard";
import UnderStockList from "./UnderStockList";

function Dashboard() {
  const values = getLocalAuth()
  const privilege = JSON.parse(values.authPrivilege);

  let dataPrivilege = privilege.data.menu.filter(data => {
    return data.code === "Dashboard"
  });

  let dataRead = dataPrivilege.length === 0 ? [] : dataPrivilege[0].action_page.filter(data => {
    return data.code === "Read"
  });

  return (
    <div>
      {dataRead.length === 0 ? <ErrorNotFound /> : !dataRead[0].is_active ? <ErrorNotFound /> :
      <div className="page-content-wrapper">
        <div className="page-content">
          <SummaryDashboard />
          <div className="row">
            <div className="col-12 col-lg-4">
              <div className="card radius-15 overflow-hidden">
                <div className="card-header border-bottom-0">
                  <div className="d-flex align-items-center">
                    <div>
                      <h5 className="mb-0">Most Used Part</h5>
                    </div>
                  </div>
                </div>
                <div className="card-body p-3" style={{ height: '320px' }}>
                  <MostUsedPart />
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-8">
              <div className="card radius-15 overflow-hidden">
                <div className="card-header border-bottom-0">
                  <div className="d-flex align-items-center">
                    <div>
                      <h5 className="mb-0">Activity Report</h5>
                    </div>
                  </div>
                </div>
                <div className="card-body p-2" style={{ height: '320px' }}>
                  <ActivityReport />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-lg-5">
              <div className="card radius-15 overflow-hidden">
                <div className="card-header border-bottom-0">
                  <div className="d-flex align-items-center">
                    <div>
                      <h5 className="mb-0">Under Stock List</h5>
                    </div>
                  </div>
                </div>
                <div className="card-body p-0" style={{ height: '300px' }}>
                  <div className="table-responsive">
                    <UnderStockList />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-7">
              <div className="card radius-15 overflow-hidden">
                <div className="card-header border-bottom-0">
                  <div className="d-flex align-items-center">
                    <div>
                      <h5 className="mb-0">Rack Storage</h5>
                    </div>
                  </div>
                </div>
                <div className="card-body p-0" style={{ height: '300px' }}>
                  <RackStorage />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>}</div>

  );
}

export default Dashboard;
